// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".с-message-template__edit-form--animation-enter{height:0}.с-message-template__edit-form--animation-enter-active{height:150px;transition:height 300ms ease-in-out}.с-message-template__edit-form--animation-exit{height:150px}.с-message-template__edit-form--animation-exit-active{height:0;transition:height 400ms ease-in-out}", ""]);
// Exports
module.exports = exports;
